import React from 'react';
import styled, { css } from 'styled-components';
import { Flex, CellWithArrow, smallBodySemiBold } from '@ubeya/shared-web/components';
import editable from '@ubeya/shared-web/style/editable';

const Wrapper = styled(Flex)`
  height: 100%;
  overflow: hidden;
  ${smallBodySemiBold};
  color: ${({ theme, color }) => color || theme.colors.black};
  ${({ color }) =>
    color &&
    css`
      &:before {
        content: '';
        position: absolute;
        left: 0;
        top: 0;
        bottom: 0;
        width: 5px;
        background: ${color};
      }
    `}

  ${({ isGroup }) =>
    !isGroup
      ? 'flex-direction: column; align-items: flex-start;justify-content: center;'
      : 'justify-content: flex-start; align-items: center;'}
  ${({ isGroup }) => !isGroup && 'padding: 7px 15px;'}
  ${({ isGroup }) => isGroup && 'margin-left: 20px;'}
  
  cursor: pointer;
  flex: 1;
  ${editable};

  svg {
    visibility: hidden;
  }
  &:hover {
    svg {
      visibility: visible;
    }
  }

  .extra {
    position: absolute;
    right: 10px;
    top: 2px;
  }
`;

const BaseRenderer = ({ isGroup, value, subTitle, isExpended, toggleRow, color, children }) => (
  <Wrapper isGroup={isGroup} onClick={toggleRow} color={color}>
    <CellWithArrow multiline isExpended={isExpended}>
      {value}
    </CellWithArrow>

    {subTitle}

    {children}
  </Wrapper>
);

export default BaseRenderer;
